import { render, staticRenderFns } from "./DossierScripts.vue?vue&type=template&id=4ae95931&"
import script from "./DossierScripts.vue?vue&type=script&lang=ts&"
export * from "./DossierScripts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae95931')) {
      api.createRecord('4ae95931', component.options)
    } else {
      api.reload('4ae95931', component.options)
    }
    module.hot.accept("./DossierScripts.vue?vue&type=template&id=4ae95931&", function () {
      api.rerender('4ae95931', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierScripts.vue"
export default component.exports